const items_featured = document.querySelectorAll('.features__item');

const observer_featured = new IntersectionObserver(entries => {
  entries.forEach((entry, index) => {
    if (entry.isIntersecting) {
      setTimeout(() => {
        entry.target.classList.add('show-featured');
      }, index * 200);
    }
  });
});

items_featured.forEach(el => observer_featured.observe(el));